import { render, staticRenderFns } from "./MyCall.vue?vue&type=template&id=d325ed18&scoped=true&"
import script from "./MyCall.vue?vue&type=script&lang=js&"
export * from "./MyCall.vue?vue&type=script&lang=js&"
import style0 from "./MyCall.vue?vue&type=style&index=0&id=d325ed18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d325ed18",
  null
  
)

export default component.exports